import React from 'react';

function Loading(_props) {
  return <div>Loading...</div>
}

export default Loading
